import { Button, TableSelectionEvent } from "@mcleod/components";
import { AutogenLayoutMiscInvoiceHistoryToolPanel } from "./autogen/AutogenLayoutMiscInvoiceHistoryToolPanel";
import { MiscInvoiceHistoryList } from "./MiscInvoiceHistoryList";
import { CommonDialogs } from "@mcleod/common";
import { ModelRow } from "@mcleod/core";
import { MultiReprintMiscBill } from "./MultiReprintMiscBill";

export class MiscInvoiceHistoryToolPanel extends AutogenLayoutMiscInvoiceHistoryToolPanel {
    private miscInvoiceHistoryListLayout: MiscInvoiceHistoryList;

    override onLoad(): void {
        this.addMountListener(() => {
            this.initialize(this.owner);
        });
    }

    private getAllVisibleButtons(): Button[] {
        return this.panelButtons?.findComponentsByType(Button)?.filter(button => button.visible);
    }

    initialize(layout: MiscInvoiceHistoryList) {
        this.miscInvoiceHistoryListLayout = layout;
        const visibleButtons = this.getAllVisibleButtons();
        if (visibleButtons?.length > 0) {
            this.miscInvoiceHistoryListLayout?.tableMiscInvoicingHistory?.addSelectionListener((event: TableSelectionEvent) => {
                this.tableOnSelect(event);
            });
        } else {
            this.removeAll();
        }
    }

    tableOnSelect(event: TableSelectionEvent) {
        this.syncToolPanel(event);
    }

    public syncToolPanel(event: TableSelectionEvent) {
        this.buttonReprintMiscBill.enabled = event.newRows?.length > 0;
        this.buttonReprintBalanceDue.enabled = event.newRows?.length > 0;
    }

    async buttonReprintMiscBillOnClick() {
        await this.openReprintSlideout(false);
    }

    async buttonReprintBalanceDueOnClick() {
        await this.openReprintSlideout(true);
    }

    async openReprintSlideout(isBalanceDue: boolean) {
        const selectedRows = this.miscInvoiceHistoryListLayout.tableMiscInvoicingHistory.selectedRows.map(row => row.data) as ModelRow[];
        if (!selectedRows || selectedRows.length === 0) {
            return;
        }

        const sendToImaging = await CommonDialogs.showYesNo("Send report to Imaging?");
        if (sendToImaging == null) {
            return;
        }

        const reprintMiscBillProps = {
            openItems: selectedRows,
            invoiceNumberFieldName: "invoice_no_string",
            isBalanceDue: isBalanceDue,
            sendToImaging: sendToImaging,
        };
        MultiReprintMiscBill.openMultiReprintSlideout(reprintMiscBillProps);
    }
}
